@if (isMobileScreen()) {
  <div class="mobile-block-overlay">
    <div class="mobile-block-card">
      <!-- Device illustration -->
      <div class="device-illustration">
        <svg viewBox="0 0 260 160" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <!-- Back device (laptop/desktop screen) -->
          <rect x="10" y="10" width="185" height="125" rx="8" fill="#dde3f5" />
          <!-- Screen bezel top bar -->
          <rect x="10" y="10" width="185" height="18" rx="8" fill="#c8d0ea" />
          <rect x="10" y="22" width="185" height="6" fill="#c8d0ea" />
          <!-- Content blocks inside back device -->
          <rect x="22" y="38" width="60" height="12" rx="3" fill="#b8c3e0" />
          <rect x="22" y="56" width="160" height="10" rx="3" fill="#c8d0ea" />
          <rect x="22" y="72" width="130" height="10" rx="3" fill="#c8d0ea" />
          <rect x="22" y="88" width="150" height="10" rx="3" fill="#c8d0ea" />
          <rect x="22" y="104" width="100" height="10" rx="3" fill="#c8d0ea" />

          <!-- Front device (tablet) -->
          <rect x="145" y="35" width="100" height="130" rx="8" fill="#eef0f8" stroke="#c8d0ea" stroke-width="2" />
          <!-- Tablet top bar -->
          <rect x="145" y="35" width="100" height="16" rx="8" fill="#d0d8ee" />
          <rect x="145" y="45" width="100" height="6" fill="#d0d8ee" />
          <!-- Content blocks inside tablet -->
          <rect x="155" y="62" width="40" height="8" rx="2" fill="#c0cbe6" />
          <rect x="155" y="76" width="80" height="8" rx="2" fill="#d0d8ee" />
          <rect x="155" y="90" width="65" height="8" rx="2" fill="#d0d8ee" />
          <rect x="155" y="104" width="75" height="8" rx="2" fill="#d0d8ee" />
          <rect x="155" y="118" width="55" height="8" rx="2" fill="#d0d8ee" />
          <rect x="155" y="132" width="70" height="8" rx="2" fill="#d0d8ee" />
          <rect x="155" y="146" width="50" height="8" rx="2" fill="#d0d8ee" />
        </svg>
      </div>

      <!-- Warning icon -->
      <div class="warning-icon-wrapper">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12 2L1.5 20.5h21L12 2z" stroke="#3451b2" stroke-width="1.8" stroke-linejoin="round" fill="none"/>
          <line x1="12" y1="10" x2="12" y2="15" stroke="#3451b2" stroke-width="1.8" stroke-linecap="round"/>
          <circle cx="12" cy="18" r="0.8" fill="#3451b2"/>
        </svg>
      </div>

      <!-- Text -->
      <h2>Unsupported Screen Size!</h2>
      <p>
        This exam portal requires a larger screen to function properly. Please switch to a desktop, laptop, or tablet to continue.
      </p>
    </div>
  </div>
} @else {
  <router-outlet />
}
